export class Endereco {
  public Logradouro = '';
  public Numero = '';
  public Complemento = '';
  public Bairro = '';
  public Cidade = '';
  public Estado = '';
  public Cep = '';
}
